import React, {  Component } from 'react';

export default class SuccessPriceTemplateConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('SuccessPriceTemplateConfirmation', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{top: 122}}>
                    <h2 className="title">Report Generated</h2>
                    <p>{this.props.saveTemplateOrNot?"Template created successfully. You will receive an email shortly with the report link.":"Report generated successfully. You will receive an email shortly with the download link."}</p>
                    <div className="floatRight">
                        <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/successPriceTemplateConfirmation.js